exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "circular-progress{display:flex;justify-content:center;align-items:center}circular-progress strong{position:absolute;font-size:24px}.progress-ring-circle{transition:stroke-dashoffset .35s;transform:rotate(-90deg);transform-origin:50% 50%}", "", {"version":3,"sources":["/./src/app/core/directives/circular-progress/circular-progress.css"],"names":[],"mappings":"AAAA,kBACE,aAAc,AACd,uBAAwB,AACxB,kBAAoB,CACrB,AACD,yBACE,kBAAmB,AACnB,cAAgB,CACjB,AACD,sBACE,kCAAoC,AACpC,yBAA0B,AAC1B,wBAA0B,CAC3B","file":"circular-progress.css","sourcesContent":["circular-progress {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\ncircular-progress strong {\n  position: absolute;\n  font-size: 24px;\n}\n.progress-ring-circle {\n  transition: 0.35s stroke-dashoffset;\n  transform: rotate(-90deg);\n  transform-origin: 50% 50%;\n}\n"],"sourceRoot":"webpack://"}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?sourceMap!./node_modules/postcss-loader!./src/app/core/directives/circular-progress/circular-progress.css
// module id = 956
// module chunks = 0